export const ENROLLMENT_USER_REVIEW = 'ENROLLMENT_USER_REVIEW';

export const enrollmentUserReview = userReviewStatus => dispatch =>
  dispatch({
    type: ENROLLMENT_USER_REVIEW,
    payload: userReviewStatus,
  });
